/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProject_ProjectJobHistories.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Project Job History API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Tuesday, July 02, 2019 - 09:00:37 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      07/02/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Project_ProjectJobHistories = {
    all: (jobid) => requests.get(`/ProjectJobHistories?jobid=${jobid}`),
    get: projectjobhistoryid => requests.get(`/ProjectJobHistory/${projectjobhistoryid}`),
    create: projectjobhistory => requests.post(`/ProjectJobHistories`, projectjobhistory),
    update: (projectjobhistoryid, projectjobhistory) => requests.put(`/ProjectJobHistory/${projectjobhistoryid}`, projectjobhistory),
    delete: projectjobhistoryid => requests.del(`/ProjectJobHistory/${projectjobhistoryid}`),
};